<input
  type="file"
  class="file-input"
  (change)="onFileSelected($event)"
  #fileUpload />

<div class="file-upload">
  <div class="file-upload-title">
    {{ title }}
  </div>
  <div class="file-upload-controller">
    {{ fileName || 'No file uploaded yet.' }}

    <button
      mat-mini-fab
      color="primary"
      class="upload-btn"
      (click)="fileUpload.click()">
      <mat-icon>attach_file</mat-icon>
    </button>
  </div>
</div>
